<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <!-- Basic Alerts start -->
    <section id="sample-page">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body pb-1">
              <div class="card-datatable text-nowrap">
                <div
                  class="d-flex mb-3"
                  style="align-items: center; justify-content: space-between"
                >
                  <div class="input-group input-group-merge w-auto">
                    <input
                      type="text"
                      id="first-name-icon"
                      class="form-control"
                      name="fname-icon"
                      placeholder="ابحث فى التسجيلات "
                      (keyup)="updateFilter($event)"
                    />
                    <span class="input-group-text">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="10"
                          cy="10.5867"
                          r="7"
                          stroke="#3F8260"
                          stroke-opacity="0.9"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 21.5867L15 15.5867"
                          stroke="#3F8260"
                          stroke-opacity="0.9"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div class="d-flex">
                    <select
                      id="per-page"
                      class="form-control pl-3 pr-0"
                      (change)="onLimitChange($event.target.value)"
                    >
                      <option
                        *ngFor="let option of pageLimitOptions"
                        [value]="option.value"
                        [selected]="option.value == currentPageLimit"
                      >
                        {{ option.value }}
                      </option>
                    </select>
                    <!-- <button class="btn btn-outline-primary waves-effect py-0 ml-2" type="button" (click)="modalOpenDefault(modalDefault)" rippleEffect>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.66602 11.9199V13.2533C2.66602 13.9896 3.26297 14.5866 3.99935 14.5866H11.9993C12.7357 14.5866 13.3327 13.9896 13.3327 13.2533V11.9199" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.66602 6.58675L7.99935 3.25342L11.3327 6.58675" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.99935 3.25342V11.2534" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                                    
                                <span class="pl-1">استخراج</span>
                            </button> -->
                    <!-- <button
                      class="btn btn-primary waves-effect py-0 ml-2"
                      type="button"
                      rippleEffect
                    >
                      + <span class="pl-1">فئة جديدة </span>
                    </button> -->

                    <div class="modal-size-default d-inline-block">
                      <ng-template #modalDefault let-modal>
                        <div class="modal-header">
                          <h5 class="modal-title" id="myModalLabel160"></h5>
                          <button
                            type="button"
                            class="close"
                            (click)="modal.dismiss('Cross click')"
                            aria-label="Close"
                           title="إغلاق">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div
                          class="modal-body text-center"
                          tabindex="0"
                          ngbAutofocus
                        >
                          <h4>استخراج ملف</h4>
                          <p class="pt-1">
                            اضغط على احدى الصيغ الاتية لبدء التحميل
                          </p>
                          <div
                            class="d-flex mt-2"
                            style="justify-content: center"
                          >
                            <button
                              class="btn btn-outline-primary waves-effect ml-1"
                              rippleEffect
                              (click)="
                                downloadFile('pdf'); modal.close('Accept click')
                              "
                            >
                              <p class="mb-50">
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_5021_101245)">
                                    <path
                                      d="M20.616 5.54L17.126 2.05C15.806 0.73 14.046 0 12.176 0H7.66602C4.90602 0 2.66602 2.24 2.66602 5V19C2.66602 21.76 4.90602 24 7.66602 24H17.666C20.426 24 22.666 21.76 22.666 19V10.49C22.666 8.62 21.936 6.86 20.616 5.54ZM19.206 6.95C19.526 7.27 19.796 7.62 20.016 8H15.676C15.126 8 14.676 7.55 14.676 7V2.66C15.056 2.88 15.406 3.15 15.726 3.47L19.216 6.96L19.206 6.95ZM20.666 19C20.666 20.65 19.316 22 17.666 22H7.66602C6.01602 22 4.66602 20.65 4.66602 19V5C4.66602 3.35 6.01602 2 7.66602 2H12.176C12.336 2 12.506 2 12.666 2.02V7C12.666 8.65 14.016 10 15.666 10H20.646C20.666 10.16 20.666 10.32 20.666 10.49V19ZM7.75602 13H6.66602C6.11602 13 5.66602 13.45 5.66602 14V18.44C5.66602 18.79 5.94602 19.06 6.28602 19.06C6.62602 19.06 6.90602 18.78 6.90602 18.44V17.22H7.74602C8.92602 17.22 9.88602 16.27 9.88602 15.11C9.88602 13.95 8.92602 13 7.74602 13H7.75602ZM7.75602 15.97H6.92602V14.25H7.76602C8.24602 14.25 8.65602 14.64 8.65602 15.11C8.65602 15.58 8.24602 15.97 7.76602 15.97H7.75602ZM19.686 13.63C19.686 13.98 19.406 14.25 19.066 14.25H17.376V15.39H18.616C18.966 15.39 19.236 15.67 19.236 16.01C19.236 16.35 18.956 16.63 18.616 16.63H17.376V18.43C17.376 18.78 17.096 19.05 16.756 19.05C16.416 19.05 16.136 18.77 16.136 18.43V13.62C16.136 13.27 16.416 13 16.756 13H19.066C19.416 13 19.686 13.28 19.686 13.62V13.63ZM12.756 13.01H11.666C11.116 13.01 10.666 13.46 10.666 14.01V18.45C10.666 18.8 10.946 19.01 11.286 19.01C11.626 19.01 12.746 19.01 12.746 19.01C13.926 19.01 14.886 18.06 14.886 16.9V15.12C14.886 13.96 13.926 13.01 12.746 13.01H12.756ZM13.646 16.9C13.646 17.37 13.236 17.76 12.756 17.76H11.926V14.26H12.766C13.246 14.26 13.656 14.65 13.656 15.12V16.9H13.646Z"
                                      fill="#3F8260"
                                      fill-opacity="0.9"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5021_101245">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                        transform="translate(0.666016)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </p>
                              <p class="mb-1 file-name">PDF</p>
                              <p class="mb-50 download">اضغط للتحميل</p>
                            </button>
                            <button
                              class="btn btn-outline-primary waves-effect"
                              rippleEffect
                              (click)="
                                downloadFile('excel');
                                modal.close('Accept click')
                              "
                            >
                              <p class="mb-50">
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_5021_101257)">
                                    <path
                                      d="M15.602 13.64L13.632 16L15.602 18.36C15.952 18.78 15.902 19.41 15.472 19.77C15.282 19.93 15.062 20 14.832 20C14.542 20 14.262 19.88 14.062 19.64L12.332 17.56L10.602 19.64C10.402 19.88 10.122 20 9.83203 20C9.60203 20 9.38203 19.92 9.19203 19.77C8.77203 19.42 8.71203 18.79 9.06203 18.36L11.032 16L9.06203 13.64C8.71203 13.22 8.76203 12.59 9.19203 12.23C9.62203 11.88 10.242 11.93 10.602 12.36L12.332 14.44L14.062 12.36C14.412 11.94 15.042 11.88 15.472 12.23C15.892 12.58 15.952 13.21 15.602 13.64ZM22.332 10.49V19C22.332 21.76 20.092 24 17.332 24H7.33203C4.57203 24 2.33203 21.76 2.33203 19V5C2.33203 2.24 4.57203 0 7.33203 0H11.842C13.712 0 15.472 0.73 16.792 2.05L20.272 5.54C21.592 6.86 22.322 8.62 22.322 10.49H22.332ZM15.382 3.46C15.062 3.14 14.712 2.87 14.332 2.65V7C14.332 7.55 14.782 8 15.332 8H19.672C19.452 7.62 19.182 7.27 18.862 6.95L15.382 3.46ZM20.332 10.48C20.332 10.32 20.332 10.15 20.312 9.99H15.332C13.682 9.99 12.332 8.64 12.332 6.99V2.02C12.172 2 12.012 2 11.842 2H7.33203C5.68203 2 4.33203 3.35 4.33203 5V19C4.33203 20.65 5.68203 22 7.33203 22H17.332C18.982 22 20.332 20.65 20.332 19V10.49V10.48Z"
                                      fill="#3F8260"
                                      fill-opacity="0.9"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_5021_101257">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                        transform="translate(0.332031)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </p>
                              <p class="mb-1 file-name">Excel</p>
                              <p class="mb-50 download">اضغط للتحميل</p>
                            </button>
                          </div>
                          <p class="note mt-2 mb-4">
                            ملحوظة : البيانات المستخرجة ستتطابق مع التصفية
                            الحالية
                          </p>
                        </div>
                      </ng-template>
                      <!-- / Modal -->
                    </div>
                  </div>
                </div>

                <!-- ngx-datatable-custom-checkbox -->
                <div class="row">
                  <div class="col-12">
                    <ngx-datatable
                      #table
                      id="ngxTable"
                      class="material bootstrap core-bootstrap"
                      [rows]="rows"
                      [columnMode]="'force'"
                      [headerHeight]="40"
                      [footerHeight]="50"
                      [limit]="10"
                      [rowHeight]="'auto'"
                      [selected]="chkBoxSelected"
                      (select)="customChkboxOnSelect($event)"
                      [scrollbarH]="true"
                      [selectAllRowsOnPage]="true"
                    >
                      <!-- <ngx-datatable-column
                            [width]="50"
                            [sortable]="false"
                            [canAutoResize]="false"
                            [draggable]="false"
                            [resizeable]="false"
                          >
                            <ng-template
                              ngx-datatable-header-template
                              let-value="value"
                              let-allRowsSelected="allRowsSelected"
                              let-selectFn="selectFn"
                            >
                              <div class="custom-control custom-control-primary custom-checkbox">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  [checked]="allRowsSelected"
                                  (change)="selectFn(!allRowsSelected)"
                                  id="headerCustomChkbxRef"
                                />
                                <label class="custom-control-label" for="headerCustomChkbxRef"></label>
                              </div>
                            </ng-template>
                            <ng-template
                              ngx-datatable-cell-template
                              let-rowIndex="rowIndex"
                              let-value="value"
                              let-isSelected="isSelected"
                              let-onCheckboxChangeFn="onCheckboxChangeFn"
                            >
                              <div class="custom-control custom-control-primary custom-checkbox">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  [checked]="isSelected"
                                  (change)="onCheckboxChangeFn($event)"
                                  id="rowCustomChkbxRef{{ rowIndex }}"
                                />
                                <label class="custom-control-label" for="rowCustomChkbxRef{{ rowIndex }}"></label>
                              </div>
                            </ng-template>
                          </ngx-datatable-column> -->
                      <ngx-datatable-column
                        name="#"
                        prop="#"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name='اسم الفعاليه'
                        prop="EventName"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name='رمز الفعاليه'
                        prop="EventId"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name= 'اسم المستخدم'
                        prop="UserName"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name='عدد الاعضاء'
                        prop='NumberOfMembers'
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name="الحاله"
                        prop="Status"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name= 'رد عمليه المسح'
                        prop="ScanResponse"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name='رمز المشرف' 
                        prop="OrganizerId"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name='اسم المشرف'
                        prop="OrganizerName"
                      ></ngx-datatable-column>
                      <ngx-datatable-column
                        name='تاريخ المسح' 
                        prop="ScannedOn"
                      ></ngx-datatable-column>
                    </ngx-datatable>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Basic Alerts end -->
  </div>
</div>
